const URL_PATTERN =
	/^(?:(?:https?|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?::\d{2,5})?(?:\/\S*)?$/i;

export const isValidWebsite = (value: string): boolean =>
	URL_PATTERN.test(value.trim());

export const normalizeWebsiteValue = (value: string): string =>
	value
		.trim()
		.replace(/^(https?:\/\/)/i, "")
		.replace(/\/$/, "");